<template>
    <div class="body">
        <p class="font1" style="padding-top: 12vh;">Hi～<span class="font1" style="font-size: 1.2rem;">{{ ReportData.stuname }}</span>，我们又见面啦</p>
        <p  class="font1" style="padding-top: 3vh;">今天是第40个教师节，而老师，是我们一生中所遇到的最重要的人之一，他们传道授业、启迪智慧、塑造灵魂。</p>
        <p class="font1" style="padding-top: 3vh;">让我们在这个日子共同感谢老师，祝我们的老师教师节快乐，幸福安康！</p>
    </div>
</template>


<script>
export default {
      props: ["ReportData"],
      data() {
        return {
        }
      },
    }
</script>
  
<style scoped>
.body {
    background: 
                url("../../assets/logo1.png") left  top  no-repeat,
                url("../../assets/teacherDay/bg.jpg")  no-repeat;
    background-size: 110px 40px,cover;
    width: 100%;
    height: 100vh;
}

.font1 {
    width: 90%;
    /* padding-left: 8%; */
    margin: 0 auto;
    text-align: justify;
    font-size: 18px;
    color: #fff;
    /* font-weight: bold; */
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 80%;
    padding-left: 8%;
    color: #000;
    font-size: 18px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 25px;
    color: #654727;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.fa{
    color:rgb(206, 144, 28);
    align-items: center;
}
</style>